import { render, staticRenderFns } from "./AddPurchaseDemand.vue?vue&type=template&id=efbb0ba4&scoped=true&"
import script from "./AddPurchaseDemand.vue?vue&type=script&lang=js&"
export * from "./AddPurchaseDemand.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efbb0ba4",
  null
  
)

export default component.exports